import capitalize from 'lodash/capitalize';

const capitalizeKeys = (object) =>
  Object.entries(object).reduce((acc, [topic, count]) => {
    acc[capitalize(topic)] = count;
    return acc;
  }, {});

export default capitalizeKeys;
